import React, { useState } from "react";
import LeMoulinApi from "app/universal/utils/LeMoulinApi";

const EditableNumbering = ({ numbering, orderId, onChange, backgroundColor = 'grey' }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [tempNumbering, setTempNumbering] = useState(numbering || "P");
  const [isSaving, setIsSaving] = useState(false);

  const isValidNumbering = (val) => /^P\d+$/.test(val);

  const saveNumbering = async () => {
    if (isValidNumbering(tempNumbering)) {
      setIsSaving(true);
      try {
        if (orderId) {
          await LeMoulinApi.request.order.v2.put(orderId, { numbering: tempNumbering });
          if (onChange) onChange(tempNumbering);
        }
      } catch (e) {
        alert("Erreur lors de la mise à jour du numbering");
      }
      setIsSaving(false);
      setIsEditing(false);
    }
  };

  return (
    <>
      <div
        style={{
          width: "50px",
          borderRadius: "4px",
          marginBottom: "0.5rem",
          color: "white",
          textShadow: "1px 1px 2px grey",
          textAlign: "center",
          backgroundColor,
          cursor: "pointer",
          minHeight: "38px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
        onClick={() => {
          setTempNumbering(numbering || "P");
          setIsEditing(true);
        }}
      >
        {isEditing ? (
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
            <input
              type="text"
              value={tempNumbering}
              autoFocus
              onChange={(e) => setTempNumbering(e.target.value)}
              onBlur={saveNumbering}
              onKeyDown={(e) => {
                if (e.key === "Enter") saveNumbering();
                if (e.key === "Escape") setIsEditing(false);
              }}
              style={{ width: "45px", textAlign: "center" }}
              maxLength={6}
              disabled={isSaving}
            />
            {isSaving && (
              <span style={{marginLeft: 18}}>
                <svg width="16" height="16" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#888">
                  <g fill="none" fillRule="evenodd">
                    <g transform="translate(1 1)" strokeWidth="2">
                      <circle strokeOpacity=".5" cx="18" cy="18" r="18"/>
                      <path d="M36 18c0-9.94-8.06-18-18-18">
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          from="0 18 18"
                          to="360 18 18"
                          dur="1s"
                          repeatCount="indefinite"/>
                      </path>
                    </g>
                  </g>
                </svg>
              </span>
            )}
          </div>
        ) : (
          numbering
        )}
      </div>
      {isEditing && (
        <div style={{textAlign: 'center', fontSize: '0.8em', color: '#888', marginTop: '2px'}}>
          Appuyez sur Entrée pour terminer l'édition
        </div>
      )}
    </>
  );
};

export default EditableNumbering; 